import React, { Component } from 'react';

class Table extends Component {
    constructor(props){
        super(props)
    }
    render() {
        return (
            <div className="dashboard-panel">
                <div className="table-responsive">
                    <table className="table-condensed table-striped table-hover table">
                        <thead>
                            <tr>
                                <th>Número</th>
                                <th>Campaña</th>
                                <th>Inicia</th>
                                <th>Finaliza</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.campañas.length > 0 ? 
                            this.props.campañas.map((val, i)=>(
                                <tr key={i}>
                                    <td>{val.id_camp}</td>
                                    <td>{val.nombre}</td>
                                    <td>{val.fechaInicio}</td>
                                    <td>{val.fechaFinalizacion}</td>
                                </tr>
                            ))
                            : 
                            <tr>
                                <td colSpan="4">
                                    <div className="alert alert-info">No tienes campañas creadas</div>
                                </td>
                            </tr>}
                        </tbody>

                    </table>
                </div>
            </div>
        );
    }
}

export default Table;


// WEBPACK FOOTER //
// ./src/components/dashboard/Table.js